export class SelectedRangeServiceImpl {
    updateSelectedRange(selectedRange) {
        throw new Error('Method not implemented.');
    }
    getSelectedRange() {
        throw new Error('Method not implemented.');
    }
    subscribe(callback) {
        throw new Error('Method not implemented.');
    }
}
